import React from 'react';
import { FiGrid, FiList } from 'react-icons/fi';

const ViewToggle = ({ viewType, setViewType }) => {
  return (
    <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
      <button
        onClick={() => setViewType('grid')}
        className={`p-2 ${viewType === 'grid' ? 'bg-gray-200 text-gray-800' : 'text-gray-600 hover:bg-gray-100'}`}
        aria-label="Grid view"
      >
        <FiGrid className="w-5 h-5" />
      </button>
      <button
        onClick={() => setViewType('list')}
        className={`p-2 ${viewType === 'list' ? 'bg-gray-200 text-gray-800' : 'text-gray-600 hover:bg-gray-100'}`}
        aria-label="List view"
      >
        <FiList className="w-5 h-5" />
      </button>
    </div>
  );
};

export default ViewToggle;